<template>
<DIV>
  <DIV
    class="form-control form-control-readonly"
    v-if="readonly"
  >
    <UcAccountSelectOption
      :payload="value"
      display-owner
    >
    </UcAccountSelectOption>
  </DIV>
  <b-dropdown
    toggle-class="border"
    variant="light"
    class="apply-inline-button"
    v-if="!readonly"
  >
    <template
      slot="button-content"
    >
      <ItpText
        :text="'Select account'|pgettext('AccountSelector')"
        v-if="!selectedAccount"
      >
      </ItpText>
      <UcAccountSelectOption
        :payload="value"
        display-owner
        v-if="selectedAccount"
      >
      </UcAccountSelectOption>
    </template>
    <b-dropdown-form
      v-if="hasInactiveItem"
    >
      <b-form-checkbox
        v-model="states.showInactive"
        @change="evh_1468474219929533_change($event, {})"
      >
        {{ 'Show inactive'|pgettext('AccountSelector') }}
      </b-form-checkbox>
    </b-dropdown-form>
    <b-dropdown-divider
      v-if="hasInactiveItem"
    >
    </b-dropdown-divider>
    <b-dropdown-group
      :id="group.id"
      :key="group.id"
      :header="group.name"
      v-for="group in accountGroups"
    >
      <b-dropdown-item-button
        :key="item.id"
        v-for="item in group.items"
        @click.prevent="evh_1306227577716690_clickPrevent($event, {group, item})"
      >
        <UcAccountSelectOption
          :payload="item"
        >
        </UcAccountSelectOption>
      </b-dropdown-item-button>
    </b-dropdown-group>
  </b-dropdown>
</DIV>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcAccountSelector extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
    this.$$cache_states = new ComponentValueCache(this, "states", () => this.$$load_states_cache_key());
  }

  $$load_states_cache_key() {
    return this.cacheKey ? ('AccountSelector.' + this.cacheKey) : null
  }

  createAccountGrups(...args: any[]) {
    const [accounts] = args;
    const showInactive = this.states.showInactive;
    const accountType = this.accountType;

    return _
      .chain(accounts)
      .filter(p => accountType ? p.account_type === accountType : true)
      .groupBy(p => p.owner.id)
      .map((items, owner_id) => ({
        id: owner_id,
        name: items[0].owner.code + ' - ' + items[0].owner.name,
        items: !showInactive ? _.filter(items, { inactive: false }) : items
      }))
      .filter(p => p.items.length)
      .value()
  }

  itemChanged(...args: any[]) {
    const [item, value] = args;

    if (value == null || item == null) {
      return true;
    }
    return value.id != item.id
  }

  @Prop({
  })
  value!: any;

  @Watch('value')
  onValue(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("value")
  }

  @Prop({
    type: Boolean,
  })
  displayOwner!: boolean;

  @Watch('displayOwner')
  onDisplay_owner(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("displayOwner")
  }

  @Prop({
    type: String,
  })
  cacheKey!: string;

  @Watch('cacheKey')
  onCache_key(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("cacheKey")
  }

  @Prop({
    type: String,
  })
  accountType!: string;

  @Watch('accountType')
  onAccount_type(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("accountType")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  accounts!: any;

  async $$load_accounts() {
    return this.$fn.fetch('list_account')
      .then(resp => _.orderBy(resp.data, ['inactive', 'account_type', 'name'], ['asc', 'desc', 'asc']))
  }

  hasInactiveItem!: any;

  async $$load_hasInactiveItem() {
    return _.some(this.$data.accounts, { inactive: true })
  }

  accountGroups!: any;

  async $$load_accountGroups() {
    return this.createAccountGrups(this.$data.accounts)
  }

  states!: any;
  ux!: any;
  dataMembers = ['accounts', 'hasInactiveItem', 'accountGroups', 'states', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        accounts: null,
        hasInactiveItem: null,
        accountGroups: null,
        states: {
          selectedAccountId: null,
          showInactive: false,
        }
        ,
        ux: null,
      },
    }
  }

  get selectedAccountType() {
    if (this.loaded) {

      return this.value && this.value.account_type
    }
    return null;
  }

  get selectedAccount() {
    if (this.loaded) {

      return _.isObject(this.value) ? this.value : null
    }
    return null;
  }

  async act_1468474219929533_setData_6516_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_1468474219929533_setData_6516, alias=undefined
    return {
      path: "accountGroups",
      value: this.createAccountGrups(this.accounts),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_1468474219929533_change(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1468474219929533_change.executeFromDOM(this, event, scope);
  }

  async act_1306227577716690_emit_6518_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1306227577716690_emit_6518, alias=undefined
    return {
      event: "input",
      value: $event.scope.item,
    }
  }

  async evh_1306227577716690_clickPrevent_6517_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1306227577716690_clickPrevent_6517, alias=undefined
    return this.itemChanged($event.scope.item, this.value)
  }

  async act_1306227577716690_setData_6520_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_1306227577716690_setData_6520, alias=undefined
    return {
      path: "states.selectedAccountId",
      value: $event.scope.item.id,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_1306227577716690_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1306227577716690_clickPrevent.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_1468474219929533_setData_6516: actions.SetDataAction;
    evh_1468474219929533_change_6515: actions.EventHandlerImpl;
    evh_1468474219929533_change: actions.EventHandlerGroup;
    act_1306227577716690_emit_6518: actions.EmitAction;
    evh_1306227577716690_clickPrevent_6517: actions.EventHandlerImpl;
    act_1306227577716690_setData_6520: actions.SetDataAction;
    evh_1306227577716690_clickPrevent_6519: actions.EventHandlerImpl;
    evh_1306227577716690_clickPrevent: actions.EventHandlerGroup;
  }

  getActions() {
    const act_1468474219929533_setData_6516 = new actions.SetDataAction(
      {
        actionArgs: this.act_1468474219929533_setData_6516_getActionArgs,
        events: [],
      }
    );
    const evh_1468474219929533_change_6515 = new actions.EventHandlerImpl(
      {
        action: act_1468474219929533_setData_6516,
        event: "change",
        displayName: "setData",
      }
    );
    const evh_1468474219929533_change = new actions.EventHandlerGroup(
      {
        handlers: [evh_1468474219929533_change_6515],
      }
    );
    const act_1306227577716690_emit_6518 = new actions.EmitAction(
      {
        actionArgs: this.act_1306227577716690_emit_6518_getActionArgs,
        events: [],
      }
    );
    const evh_1306227577716690_clickPrevent_6517 = new actions.EventHandlerImpl(
      {
        action: act_1306227577716690_emit_6518,
        event: "click.prevent",
        when: this.evh_1306227577716690_clickPrevent_6517_getWhen,
        displayName: "emit",
      }
    );
    const act_1306227577716690_setData_6520 = new actions.SetDataAction(
      {
        actionArgs: this.act_1306227577716690_setData_6520_getActionArgs,
        events: [],
      }
    );
    const evh_1306227577716690_clickPrevent_6519 = new actions.EventHandlerImpl(
      {
        action: act_1306227577716690_setData_6520,
        event: "click.prevent",
        displayName: "setData",
      }
    );
    const evh_1306227577716690_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_1306227577716690_clickPrevent_6517, evh_1306227577716690_clickPrevent_6519],
      }
    );
    return {
      act_1468474219929533_setData_6516,
      evh_1468474219929533_change_6515,
      evh_1468474219929533_change,
      act_1306227577716690_emit_6518,
      evh_1306227577716690_clickPrevent_6517,
      act_1306227577716690_setData_6520,
      evh_1306227577716690_clickPrevent_6519,
      evh_1306227577716690_clickPrevent,
    }
  }
}

Vue.component("UcAccountSelector", UcAccountSelector);

</script>